// @vendors
import * as React from "react";

// @components
import { DataTable } from "../../Admin";
import DynamicPagination from "../../../../helpers/DynamicPagination";

export const CustomPagination = (props) => {
  const {
    rowsState,
    setRowsState,
    getAllCompanies,
  } = React.useContext(DataTable);

  return (
    <>
      <DynamicPagination rowsState={rowsState} setRowsState={setRowsState} fetchData={getAllCompanies}/>
    </>
  );
};
